exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tos-modal li[data-v-2789a1c0] {\n  margin-bottom: 10px;\n}\n.tos-modal li ol[data-v-2789a1c0] {\n  margin-top: 10px;\n  list-style-type: lower-alpha;\n}\n.tos-modal ol li em[data-v-2789a1c0] {\n  font-weight: bold;\n  text-decoration: underline;\n  font-style: normal;\n}\n.wrapper[data-v-2789a1c0] {\n    overflow-y: auto;\n    width: 75%;\n    margin: auto;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2789a1c0","scoped":true,"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/t1/Admin/Tos.vue
// module id = 1555
// module chunks = 0